import { apiFetch } from '@m/utils/http';

import { KioskValidationDetail } from '../types';

export const ValidationService = {
  getValidationDetails: (shortCode: string) =>
    apiFetch<KioskValidationDetail>(`/kiosk/${shortCode}/details`),

  validateVisit: ({
    shortCode,
    licensePlateText,
  }: {
    licensePlateText: string;
    shortCode: string;
  }) =>
    apiFetch<KioskValidationDetail>(`/kiosk/${shortCode}/validate`, {
      method: 'POST',
      body: {
        text: licensePlateText,
      },
    }),
};
